import MemberItem from '@/components/member-Item';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import styles from './index.module.scss';

interface SearchMemberSelectProps {
  data: ChatGroupMember[];
  value: ChatGroupMember[];
  leftExtra?: (item: ChatGroupMember) => React.ReactNode;
  onSelect: (selectUsers: ChatGroupMember[]) => void;
}
const SearchMemberSelect = ({
  data,
  value,
  leftExtra,
  onSelect,
}: SearchMemberSelectProps) => {
  const [selectUsers, setSelectUsers] = useState<ChatGroupMember[]>([]);
  const [searchText, setSearchText] = useState<string>('');

  const data_ = useMemo(() => {
    return data?.filter((item) => item.name?.includes(searchText));
  }, [searchText, data]);

  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  }, []);

  const handleToggleUser = useCallback((item: ChatGroupMember) => {
    setSelectUsers((prev) =>
      prev.some((user) => user.user_id === item.user_id)
        ? prev.filter((user) => user.user_id !== item.user_id)
        : [...prev, item]
    );
  }, []);

  const handleRemove = useCallback(
    (item: ChatGroupMember) => () => {
      setSelectUsers((prev) => prev.filter((user) => user.user_id !== item.user_id));
    },
    []
  );

  useEffect(() => {
    onSelect(selectUsers);
  }, [onSelect, selectUsers]);

  useEffect(() => {
    setSelectUsers(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.length]);

  return (
    <div className={styles.searchMemberSelect}>
      <div className={styles.left}>
        <Input
          value={searchText}
          prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          variant="filled"
          placeholder="Search"
          onChange={handleSearch}
        />
        <div className={styles.list}>
          {data_?.map((item) => {
            return (
              <MemberItem
                key={item.user_id}
                name={item.name}
                avatar={item.avatar}
                checked={!!selectUsers.find((user) => user.user_id === item.user_id)}
                //  disabled={index == 1}
                onClick={() => handleToggleUser(item)}
                extra={leftExtra?.(item)}
              />
            );
          })}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.title}>Selected: {selectUsers.length} Member</div>
        <div className={styles.list}>
          {selectUsers?.map((item) => {
            return (
              <MemberItem
                key={item.user_id}
                name={item.name}
                avatar={item.avatar}
                showCheck={false}
                extra={
                  <div className={styles.remove} onClick={handleRemove(item)}>
                    <CloseOutlined />
                  </div>
                }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SearchMemberSelect;
